export { default } from './getMaximumDuration'
